// import React, { useState, useEffect } from "react";
// import { FaMapMarkerAlt, FaMobileAlt, FaPlay, FaTimes } from "react-icons/fa";
// import Slider from "react-slick";
// import Button from "../ui/Button";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// export default function Hero() {
//   const [typedText, setTypedText] = useState("");
//   const fullText = "Your Everyday Ride, Simplified.";

//   useEffect(() => {
//     let index = 0;
//     const timer = setInterval(() => {
//       if (index <= fullText.length) {
//         setTypedText(fullText.slice(0, index));
//         index++;
//       } else clearInterval(timer);
//     }, 80);
//     return () => clearInterval(timer);
//   }, []);

//   const banners = ["/images/1.png", "/images/2.png", "/images/3.png"];

//   const sliderSettings = {
//     dots: true,
//     infinite: true,
//     autoplay: true,
//     autoplaySpeed: 4000,
//     fade: true,
//     arrows: false,
//     pauseOnHover: false,
//   };

//   return (
//     <section
//       id="home"
//       style={{
//         position: "relative",
//         minHeight: "100vh",
//         overflow: "hidden",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       {/* Background Slider */}
//       <Slider {...sliderSettings} style={{ width: "100%", height: "100%" }}>
//         {banners.map((src, i) => (
//           <div key={i}>
//             <img
//               src={src}
//               alt={`Banner ${i + 1}`}
//               style={{
//                 width: "100%",
//                 height: "100vh",
//                 objectFit: "cover",
//                 filter: "brightness(0.8)",
//               }}
//             />
//           </div>
//         ))}
//       </Slider>

//       {/* Overlay */}
//       <div
//         style={{
//           position: "absolute",
//           inset: 0,
//           background:
//             "linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0.2))",
//           zIndex: 2,
//         }}
//       />

//       {/* Hero Content */}
//       <div
//         style={{
//           position: "absolute",
//           bottom: "10%",
//           left: "50%",
//           transform: "translateX(-50%)",
//           textAlign: "center",
//           zIndex: 5,
//           color: "#fff",
//         }}
//       >
//         <h1
//           style={{
//             fontSize: "clamp(36px, 7vw, 80px)",
//             fontWeight: "bold",
//             marginBottom: "10px",
//           }}
//         >
//           <div>Ride Smart,</div>
//           <div
//             style={{
//               background: "linear-gradient(to right, #E63946, #FFC300)",
//               WebkitBackgroundClip: "text",
//               WebkitTextFillColor: "transparent",
//             }}
//           >
//             Travel Fast
//           </div>
//         </h1>

//         <p
//           style={{
//             fontSize: "clamp(18px, 3vw, 28px)",
//             color: "#f1f1f1",
//             marginBottom: "28px",
//             fontWeight: "500",
//           }}
//         >
//           {typedText}
//           <span style={{ animation: "blink 1s infinite" }}>|</span>
//         </p>

//         {/* 🔒 Buttons are commented out below — visible in VS Code but won’t render */}
//         {/*
//         <div
//           style={{
//             display: "flex",
//             gap: "16px",
//             justifyContent: "center",
//             flexWrap: "wrap",
//           }}
//         >
//           <Button
//             onClick={() => setShowBooking(true)}
//             style={{
//               fontSize: "clamp(14px, 2vw, 18px)",
//               padding: "14px 28px",
//               borderRadius: "50px",
//               display: "flex",
//               alignItems: "center",
//               gap: "10px",
//             }}
//           >
//             <FaMobileAlt />
//             <span>Book Your Ride →</span>
//           </Button>

//           <Button
//             variant="outline"
//             onClick={() => setShowDemo(true)}
//             style={{
//               fontSize: "clamp(14px, 2vw, 18px)",
//               padding: "14px 28px",
//               borderRadius: "50px",
//               display: "flex",
//               alignItems: "center",
//               gap: "10px",
//               color: "#fff",
//               borderColor: "#fff",
//             }}
//           >
//             <FaPlay />
//             <span>Watch Demo</span>
//           </Button>
//         </div>
//         */}
//       </div>

//       {/* Animations */}
//       <style>{`
//         @keyframes blink {
//           0%, 100% { opacity: 1; }
//           50% { opacity: 0; }
//         }

//         .slick-dots li button:before {
//           color: white;
//           opacity: 0.7;
//         }

//         .slick-dots li.slick-active button:before {
//           color: #FFC300;
//         }
//       `}</style>
//     </section>
//   );
// }



















































































import React, { useState, useEffect } from "react";
import { FaMapMarkerAlt, FaMobileAlt, FaPlay, FaTimes } from "react-icons/fa";
import Slider from "react-slick";
import Button from "../ui/Button";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function Hero() {
  const [typedText, setTypedText] = useState("");
  const fullText = "Your Everyday Ride, Simplified.";

  useEffect(() => {
    let index = 0;
    const timer = setInterval(() => {
      if (index <= fullText.length) {
        setTypedText(fullText.slice(0, index));
        index++;
      } else clearInterval(timer);
    }, 80);
    return () => clearInterval(timer);
  }, []);

  const banners = ["/images/1.png", "/images/2.png", "/images/3.png"];

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    fade: true,
    arrows: false,
    pauseOnHover: false,
  };

  return (
    <section
      id="home"
      style={{
        position: "relative",
        minHeight: "100vh",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Background Slider */}
      <Slider {...sliderSettings} style={{ width: "100%", height: "100%" }}>
        {banners.map((src, i) => (
          <div key={i}>
            <img
              src={src}
              alt={`Banner ${i + 1}`}
              style={{
                width: "100%",
                height: "100vh",
                objectFit: "cover",
                filter: "brightness(0.8)",
              }}
            />
          </div>
        ))}
      </Slider>

      {/* Overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0.2))",
          zIndex: 2,
        }}
      />

      {/* Hero Content */}
      <div
        className="hero-content"
        style={{
          position: "absolute",
          bottom: "10%",
          left: "50%",
          transform: "translateX(-50%)",
          textAlign: "center",
          zIndex: 5,
          color: "#fff",
        }}
      >
        <h1
          style={{
            fontSize: "clamp(36px, 7vw, 80px)",
            fontWeight: "bold",
            marginBottom: "10px",
          }}
        >
          <div>Ride Smart,</div>
          <div
            style={{
              background: "linear-gradient(to right, #E63946, #FFC300)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Travel Fast
          </div>
        </h1>

        <p
          style={{
            fontSize: "clamp(18px, 3vw, 28px)",
            color: "#f1f1f1",
            marginBottom: "28px",
            fontWeight: "500",
          }}
        >
          {typedText}
          <span style={{ animation: "blink 1s infinite" }}>|</span>
        </p>
      </div>

      {/* Responsive Styling */}
      <style>{`
        @keyframes blink {
          0%, 100% { opacity: 1; }
          50% { opacity: 0; }
        }

        .slick-dots li button:before {
          color: white;
          opacity: 0.7;
        }
        .slick-dots li.slick-active button:before {
          color: #FFC300;
        }

        /* -------------------------
           📱 MOBILE ONLY (below 768px)
        ---------------------------*/
        @media (max-width: 768px) {

          /* Improve image center alignment */
          #home img {
            object-position: center !important;
          }

          /* Move text slightly up */
          #home .hero-content {
            bottom: 18% !important;
            width: 90%;
          }

          /* Smaller title for mobile */
          #home h1 {
            font-size: 32px !important;
          }

          #home h1 div:last-child {
            font-size: 32px !important;
          }

          /* Smaller subtitle */
          #home p {
            font-size: 16px !important;
          }
        }

        /* -------------------------
           📱 TABLET (768px to 1024px)
        ---------------------------*/
        @media (min-width: 768px) and (max-width: 1024px) {
          
          #home .hero-content {
            bottom: 14% !important;
          }

          #home h1 {
            font-size: 48px !important;
          }

          #home h1 div:last-child {
            font-size: 48px !important;
          }

          #home p {
            font-size: 20px !important;
          }
        }
      `}</style>
    </section>
  );
}
